export const GOOD_FAITH_OFFER_SESSION_KEY = "soc-good-faith-offer-active";

export const isGoodFaithOfferSessionActive = () => {
  if (typeof window === "undefined") return false;
  return window.sessionStorage.getItem(GOOD_FAITH_OFFER_SESSION_KEY) === "true";
};

export const activateGoodFaithOfferSession = () => {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(GOOD_FAITH_OFFER_SESSION_KEY, "true");
};

export const deactivateGoodFaithOfferSession = () => {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(GOOD_FAITH_OFFER_SESSION_KEY);
};

export const resolveGoodFaithHomePath = (homePath = "/") => homePath;
